import { render, staticRenderFns } from "./PaymentItem.vue?vue&type=template&id=33f654b6"
import script from "./PaymentItem.vue?vue&type=script&lang=ts"
export * from "./PaymentItem.vue?vue&type=script&lang=ts"
import style0 from "./PaymentItem.vue?vue&type=style&index=0&id=33f654b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports